import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 베이스 라인 필터 그룹 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getFilterGroup() {
    return axios.get(`${baseUrl}/settings/lms-baseline/get-filter-group.do`);
  },
  /**
   * 필터 목록 조회.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFilterList(params) {
    return axios.post(`${baseUrl}/settings/lms-baseline/get-filter-list.do`, params);
  },
  /**
   * 선택한 필터의 베이스라인을 조회한다.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFilterBaseline(params) {
    return axios.post(`${baseUrl}/settings/lms-baseline/get-filter-baseline.do`, params);
  },
  /**
   * 베이스라인 설정 업데이트
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateLmsBaseline(params) {
    return axios.post(`${baseUrl}/settings/lms-baseline/update-lms-baseline.do`, params);
  },
  /**
   * 베이스 라인 데이터 초기화
   * @author leesy918
   * @param  {[type]} params [description]
   */
  resetBaselineData(params) {
    return axios.post(`${baseUrl}/settings/lms-baseline/reset-baseline-data.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-baseline-setting.js